/* eslint-disable no-extra-boolean-cast */
import { Grid, Icon, IconButton, InputAdornment, Tooltip } from "@mui/material";
import MDInput from "components/Basics/MDInput";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { display } from "redux-react/reducers/snackBarReducer";
import { v4 } from "uuid";

const generateApiKey = () => {
	return v4();
};

/**
 * Special input for webhook
 * @returns
 */
const InputWebhook = ({ label, value, item, onChange }) => {
	const dispatch = useDispatch();
	const [apiKey, setApiKey] = useState(value);

	const baseUrl = item?.webhook?.baseUrl;
	const url = `${baseUrl}?apiKey=${apiKey}`;
	// Regenerate the API key
	const regenerate = () => {
		const newApiKey = generateApiKey();
		setApiKey(newApiKey);
		onChange(newApiKey);
	};

	useEffect(() => {
		if (!value) {
			regenerate();
		}
	}, []);

	return (
		<Grid
			size="grow"
			sx={{
				flexBasis: "66.666%",
				minWidth: "66.666%"
			}}
		>
			<MDInput
				fullWidth
				label={label}
				value={url}
				disabled
				InputProps={{
					endAdornment: (
						<InputAdornment position="end">
							<Tooltip placement="top" title={t("SETTINGS.regenerate")}>
								<IconButton color="info" style={{ pointerEvents: "visible" }} onClick={regenerate}>
									<Icon>autorenew</Icon>
								</IconButton>
							</Tooltip>
							<Tooltip placement="top" title={t("SETTINGS.DICTIONARY.copyToClipboard")}>
								<IconButton
									color="info"
									style={{ pointerEvents: "visible" }}
									onClick={() => {
										navigator.clipboard.writeText(url);
										dispatch(
											display({
												message: t("FORMS.copyToClipboard"),
												type: "info"
											})
										);
									}}
								>
									<Icon>copy</Icon>
								</IconButton>
							</Tooltip>
						</InputAdornment>
					)
				}}
			/>
		</Grid>
	);
};
export default InputWebhook;
